module.exports = __webpack_public_path__ + "img/icon_contact.035815cc.png";